export const HIDDEN_COUNTRIES = ['HK', 'XX'];